import React, { useState } from 'react';
import { cn } from '../../lib/cn';

function fallbackCopy(text) {
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.setAttribute('readonly', '');
  ta.style.position = 'fixed';
  ta.style.opacity = '0';
  document.body.appendChild(ta);
  ta.select();
  try {
    document.execCommand('copy');
  } catch (e) {
    /* ignore */
  }
  document.body.removeChild(ta);
}

const CopyButton = ({ value, label = 'Copy', className }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) await navigator.clipboard.writeText(value);
      else fallbackCopy(value);
    } catch (e) {
      fallbackCopy(value);
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1500);
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      aria-label={`Copy ${value}`}
      className={cn(
        'min-w-[64px] shrink-0 cursor-pointer rounded-[10px] border-2 border-ink bg-sun px-3 py-1.5 text-[13px] font-bold shadow-hard-sm transition-transform active:translate-x-0.5 active:translate-y-0.5 active:shadow-none',
        className
      )}
    >
      <span aria-live="polite">{copied ? 'Copied' : label}</span>
    </button>
  );
};

export default CopyButton;
